import Modal from '@mui/material/Modal';
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
export default function JavascriptMod() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen} style={{color:'teal'}}>Introduction to Java Script</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        
      >
        <Box sx={style} height={300} width={300} style={{'background':'aquamarine'}}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Introduction to Java Script
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          A powerful, high-level, and dynamic programming language primarily used to create interactive and dynamic web pages.<br/>
It's one of the core technologies of the World Wide Web, along with HTML and CSS.<br/>
It runs in web browsers, enabling features like:<br/>
Dynamic updates without reloading the page<br/>
User interactions (buttons, forms, animations)<br/>
Data validation<br/>
Games and multimedia experiences.

          </Typography>
        </Box>
      </Modal>
    </div>
  );
}